import { lazy } from 'react';

/** Wave-2 lazy account routes (DON-PR-02 / enterprise wave PR-19 appendix). */
export const AccountRecurringSetupPage = lazy(() =>
  import('../features/account/AccountRecurringSetupPage.js').then((module) => ({
    default: module.AccountRecurringSetupPage,
  }))
);

export const WAVE2_ACCOUNT_LAZY_ROUTE_IDS = ['account-recurring-donations'] as const;
